export const messages = {
  en: {
    visitFinish: {
      title: 'Visitor Finished Orders',
      back: 'Back',
      refresh: 'Refresh',
      visitorId: 'Visitor ID',
      visitor: 'Visitor',
      ownerName: 'Owner Name',
      visitReason: 'Visit Reason/Type',
      carNumber: 'Car Number',
      entourage: 'Entourage',
      createTime: 'Create Time',
      visitTime: 'Visit/Departure Time',
      status: 'Status',
      operation: 'Operation',
      detail: 'Detail',
      male: 'Male',
      female: 'Female',
      happyEvent: 'Happy Event',
      funeral: 'Funeral',
      other: 'Other',
      fetchError: 'Failed to fetch visitor data'
    }
  },
  zh: {
    visitFinish: {
      title: '访客已办单',
      back: '返回',
      refresh: '刷新',
      visitorId: '访客ID',
      visitor: '访客',
      ownerName: '业主姓名',
      visitReason: '来访事由/类型',
      carNumber: '车牌号',
      entourage: '随行人数',
      createTime: '创建时间',
      visitTime: '来访/离开时间',
      status: '状态',
      operation: '操作',
      detail: '详情',
      male: '男',
      female: '女',
      happyEvent: '喜事',
      funeral: '白事',
      other: '其他',
fetchError: '获取访客数据失败'
    }
  },
  'zh-TW': {
    visitFinish: {
      title: '訪客已辦單',
      back: '返回',
      refresh: '刷新',
      visitorId: '訪客ID',
      visitor: '訪客',
      ownerName: '業主姓名',
      visitReason: '來訪事由/類型',
      carNumber: '車牌號',
      entourage: '隨行人數',
      createTime: '創建時間',
      visitTime: '來訪/離開時間',
      status: '狀態',
      operation: '操作',
      detail: '詳情',
      male: '男',
      female: '女',
      happyEvent: '喜事',
      funeral: '白事',
      other: '其他',
      fetchError: '獲取訪客數據失敗'
    }
  }
}